(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-grid-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".custom-image-grid-video").forEach(section => {
        const container = section.querySelector(".image-video-container.has-video");
        if (!container) return;

        const hoverVideo = container.querySelector(".hover-video");
        const fullVideo = container.querySelector(".full-video");
        const placeholder = container.querySelector(".placeholder");
        const playButton = container.querySelector(".play-button");

        container.addEventListener("mouseenter", () => {
            hoverVideo.play();
        });

        container.addEventListener("mouseleave", () => {
            hoverVideo.pause();
            hoverVideo.currentTime = 0; // Reset hover video
        });

        container.addEventListener("click", () => {
            if (fullVideo.paused) {
                fullVideo.style.zIndex = "6";
                fullVideo.play();
                placeholder.style.display = "none";
                hoverVideo.style.display = "none";
                playButton.style.display = "none";
            } else {
                fullVideo.pause();
                fullVideo.style.zIndex = "0";
                placeholder.style.display = "block";
                hoverVideo.style.display = "block";
                playButton.style.display = "block";
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noili-youtube"] && !Shopify.designMode) return;
  try {
    
window.loadYoutube = function(el) {
  const wrapper = el.closest('.youtube-wrapper-inner');
  const isMobile = window.innerWidth < 768;
  const url = isMobile ? wrapper.dataset.mobileUrl : wrapper.dataset.desktopUrl;
  const videoId = getYoutubeId(url);

  if (!videoId) {
    console.error('Invalid YouTube URL');
    return;
  }

  const iframe = document.createElement('iframe');
  iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute('allow', 'autoplay; encrypted-media');
  iframe.style.width = '100%';
  iframe.style.height = '100%';

  wrapper.innerHTML = '';
  wrapper.appendChild(iframe);
};

function getYoutubeId(url) {
  const match = url.match(/(?:v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : '';
}

  } catch(e) { console.error(e); }
})();
})();
